'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _prep = require('./internal/prep');

var _prep2 = _interopRequireDefault(_prep);

var _count = require('./count');

var _count2 = _interopRequireDefault(_count);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _prep2.default)({
    name: 'isEmpty',
    immutable: 'isEmpty',
    record: function record() {
        return function (value) {
            return value.equals(new value.constructor());
        };
    },
    object: function object() {
        return function (value) {
            return (0, _count2.default)()(value) === 0;
        };
    },
    array: function array() {
        return function (value) {
            return (0, _count2.default)()(value) === 0;
        };
    }
});


//////////////////
// WEBPACK FOOTER
// ./~/unmutable/lib/isEmpty.js
// module id = 268
// module chunks = 35783957827783